import { ca } from '@cian/analytics';

import { type PinService } from '@/microfrontends/map/shared/services/PinService';
import { PIN_TYPES } from '@/microfrontends/map/shared/utils/mapModules/PinsLayer/types';

const prepareLabel = (pinService: PinService, zoom: number): string => {
  const pinType = pinService.provideType();

  const pinColor = pinType === PIN_TYPES.regular ? 'blue' : 'white';

  return `${pinColor}/${zoom}`;
};

export function trackMapPinClick(pinService: PinService, zoom: number): void {
  ca('eventSite', {
    action: 'Click_pin',
    category: 'Map',
    label: prepareLabel(pinService, zoom),
    name: 'oldevent',
  });
}
